import { Button, Card, CardContent, Typography } from "@altimateai/lego";
import { Link } from "react-router-dom";

const DatamateNotFound = () => {
  return (
    <Card>
      <CardContent className="al-pt-4">
        <Typography variant="h3">Datamate not found</Typography>
        <Typography variant="body" className="al-mb-4 al-mt-2">
          The datamate you are looking for does not exist. Please check the URL and try again.
        </Typography>
        <Button asChild>
          <Link to="/datamates">Go to Datamates</Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default DatamateNotFound;
